import { render } from "./ScreenFactsBP.vue?vue&type=template&id=0d851279&scoped=true&ts=true"
import script from "./ScreenFactsBP.vue?vue&type=script&lang=ts"
export * from "./ScreenFactsBP.vue?vue&type=script&lang=ts"

import "./ScreenFactsBP.vue?vue&type=style&index=0&id=0d851279&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d851279"]])

export default __exports__